<template>
  <!-- <page>
    <v-card>
      <v-card-title primary-tile>
        <h6 class="headline mb-0">Policy Schedule - Hull</h6>
      </v-card-title>
      <v-card-text> -->
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-file-document-box</v-icon>
              <v-toolbar-title>Hull Schedule</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-btn text icon color="primary" title="Load Report History" @click="viewRptHistory">
                <v-icon>mdi-archive</v-icon>
                <rpt-jobs-history title="Report History" id="cargoSchedule" v-model="rptHistory" @close="doClose"></rpt-jobs-history>
              </v-btn> -->
            </v-toolbar>
            <v-card-text>
              <form>
                <h4>This UI is for testing purpose only, calling procedures are yet to be designed</h4>
                <message :messages="messages"></message>
                <v-container fluid grid-list-lg>
                  <v-card-title>
                    <div class="body-2">Primary Filter</div>
                  </v-card-title>
                  <v-layout row wrap>
                    <v-flex xs6 md6>
                      <v-text-field v-model="form.polNo" :label="labels.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="labels.polNo" v-validate="'required'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 md6>
                      <v-text-field type="number" v-model="form.renCnt" :label="labels.renCnt" :error-messages="errors.collect('renCnt')" data-vv-name="renCnt" :data-vv-as="labels.renCnt" v-validate="'required|mask_decimal:0|mask_min_value:0'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 md6>
                      <v-text-field type="number" v-model="form.endtCnt" :label="labels.endtCnt" :error-messages="errors.collect('endtCnt')" data-vv-name="endtCnt" :data-vv-as="labels.endtCnt" v-validate="'required|mask_decimal:0|mask_min_value:0'"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container fluid grid-list-lg>
                  <v-card-title>
                    <div class="body-2">Primary Filter</div>
                  </v-card-title>
                  <v-layout row wrap>
                    <v-flex xs6 md6>
                      <v-text-field type="number" v-model="form.noPrtSched" :label="labels.noPrtSched" :error-messages="errors.collect('noPrtSched')" data-vv-name="noPrtSched" :data-vv-as="labels.noPrtSched" v-validate="'required|mask_decimal:0|mask_min_value:0'"></v-text-field>
                    </v-flex>
                    <v-flex xs6 md6>
                      <v-text-field v-model="form.callingProg" :label="labels.callingProg" :error-messages="errors.collect('callingProg')" data-vv-name="callingProg" :data-vv-as="labels.callingProg" v-validate="''"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6 class="pt-3">
                      <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                        <v-icon left dark>mdi-file-export</v-icon>
                        {{labels.export}}
                      </v-btn>
                      <v-btn-toggle dense mandatory v-model="form.format">
                        <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                          <span>{{format.label}}</span>
                          <v-icon :color="format.color">{{format.icon}}</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </v-flex>
                  </v-layout>
                </v-container>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
      <!-- </v-card-text>
    </v-card>
  </page> -->
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
export default {
  data() {
    return {
      labels: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        endtCnt: 'Endt Count',
        noPrtSched: 'No. Print Policy Schedule',
        callingProg: 'Calling Program',
        export: 'Export to'
      },
      form: {
        polNo: '',
        renCnt: '',
        endtCnt: '',
        noPrtSched: 0,
        callingProg: '',
        format: 'PDF',
        sendEmail: false
      },
      menu: {},
      supportedFormat: [],
      submitting: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initUWMiscSched
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export_Hull
      if (apiURI) {
        this.submiting = true
        try {
          var sendForm = clone(this.form)
          await this.$http.post(apiURI, sendForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Sent form to API failed. Please validate the field')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>
